import {internalProps} from '../../../types/BS_types'

export const showDownloadAllArtifactsLink =
  internalProps['teamcity.ui.showDownloadAllArtifactsLink'] !== false
